import api from './config'

export function getBasic(
    employer_id
) {
    return api.post('platform/employer/getBasic', {
        employer_id
    })
}